/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_Col_Text_InputInputs */



/**
* | output |
* | --- |
* | "Text input" |
*
* @param {Model_Pricing_Col_Text_InputInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_col_text_input = /** @type {((inputs?: Model_Pricing_Col_Text_InputInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_Col_Text_InputInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Texteingabe")
	return /** @type {LocalizedString} */ ("Text input")
});